import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Paragraph, Image, Link } from 'components/atoms';
import './FeaturedCard.scss';

const ShowFeaturedTagPages = ({pageType}) => {
    switch (pageType) {
        case 'PSP':      
            return <span className="FeaturedTag">Featured</span>;
        default:
            return null;
    }
}

const FeaturedCard = ({ contentCard, index, totalItems, pageType }) => {
    const cardClass = classNames('featured-cards-container', {
        // 3 cards: original layout
        'card-left-large': totalItems === 3 && index === 0,
        'card-right-top': totalItems === 3 && index === 1,
        'card-right-bottom': totalItems === 3 && index === 2,

        // 4 cards: all equal sized
        'card-equal-size': totalItems === 4,

        'full-space': contentCard?.layout,
        'plain-space': contentCard?.plain
    });
    return (
        <Link className={`${cardClass} featured-card-link`} href={contentCard?.link} target="_blank" hideBorder key={contentCard?.title}>

            <div className="container-image">
                {index === 0 && (
                    <ShowFeaturedTagPages pageType={pageType} />
                )}
                <Image
                    src={contentCard?.image}
                    alt={contentCard?.title || 'Blog post image'}
                    className="featured-unit-cards-image"
                    forceLazyLoad={true}
                />
            </div>
            <div className="featured-unit-cards-head-content">
                <Paragraph weight="ultraBold" size="smaller" color="badge">{contentCard?.title}</Paragraph>
                <Paragraph weight="ultraBold" size="medium">{contentCard?.content}</Paragraph>
                <Paragraph size="smaller" weight="standard">{contentCard?.date}</Paragraph>
            </div>
        </Link>
    );
};

ShowFeaturedTagPages.propTypes = {
    pageType: PropTypes.string,
};

FeaturedCard.propTypes = {
    contentCard: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    totalItems: PropTypes.number.isRequired,
    pageType: PropTypes.string,
};

export default FeaturedCard;